import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import CallToAction from '../components/CallToAction';
import './Academy.css';

// Import images
import academyLogo from '../assets/images/ProgenX Akademi.png';
import progenxakademiHeroImage from '../assets/images/progenxakademi.jpg';
import webAppBadge from '../assets/images/web-app-badge.png';
import googlePlayBadge from '../assets/images/google-play-badge.png';
import appStoreBadge from '../assets/images/app-store-badge.png';

const Academy = () => {
  return (
    <div className="academy">
      <Helmet>
        <title>ProgenX Akademi | Yapay Zeka Destekli Kişiselleştirilmiş Eğitim Platformu 2025</title>
        <meta name="description" content="ProgenX Akademi, yapay zeka destekli kişiselleştirilmiş eğitim platformu. Öğrencilerin bireysel ihtiyaçlarına göre hazırlanan özel programlar, unutma eğrisine dayalı geri bildirimler ve yapay zeka destekli soru çözümleri ile eğitimde fark yaratıyoruz. LGS, YKS, 5-7. sınıf paketleri ile her seviyeye uygun çözümler." />
        <meta name="keywords" content="progenx akademi, yapay zeka eğitim, kişiselleştirilmiş eğitim, eğitim platformu, yapay zeka soru çözümü, eğitimde yapay zeka, lgs hazırlık, yks hazırlık, online eğitim, akıllı öğrenme, unutma eğrisi, adaptif öğrenme" />
        <meta property="og:title" content="ProgenX Akademi | Yapay Zeka Destekli Eğitim Platformu" />
        <meta property="og:description" content="Yapay zeka destekli kişiselleştirilmiş öğrenme deneyimi. Her öğrencinin bireysel ihtiyaçlarına göre optimize edilmiş eğitim programları." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenxacademy.com/progenxakademi" />
        <meta property="og:image" content="https://progenxacademy.com/progenxakademi.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="ProgenX Akademi | Yapay Zeka Destekli Eğitim Platformu" />
        <meta name="twitter:description" content="Yapay zeka destekli kişiselleştirilmiş öğrenme deneyimi sunan eğitim platformu." />
        <link rel="canonical" href="https://progenxacademy.com/progenxakademi" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "ProgenX Akademi",
            "description": "Yapay zeka destekli kişiselleştirilmiş eğitim platformu",
            "url": "https://app.progenxacademy.com",
            "applicationCategory": "EducationalApplication",
            "operatingSystem": "Web, iOS, Android",
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "TRY"
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "5.0",
              "ratingCount": "1000"
            },
            "provider": {
              "@type": "Organization",
              "name": "ProgenX",
              "url": "https://progenxacademy.com"
            }
          })}
        </script>
      </Helmet>
      
      <Hero 
        title="PROGENX AKADEMİ" 
        backgroundImage={progenxakademiHeroImage}
      />
      
      <section className="academy-content">
        <div className="container">
          <div className="academy-header">
            <img src={academyLogo} alt="ProgenX Akademi Logo" className="academy-logo" />
            <h2 className="section-title">Yapay Zeka Destekli Eğitim Platformu</h2>
          </div>
          
          <div className="academy-description">
            <p>
              Progenx, eğitimde fırsat eşitliği sağlamayı ve her öğrencinin bireysel öğrenme ihtiyaçlarına göre kişiselleştirilmiş çözümler sunarak akademik başarılarını artırmayı amaçlayan yapay zeka destekli bir platformdur. Eğitimde geleneksel yöntemlerin sınırlı kaldığı noktada devreye girerek, öğrencilerin bireysel potansiyellerini en üst düzeye çıkarmayı hedeflemektedir. Amacımız, güçlü ve zayıf yönlere dayalı kişiselleştirilmiş öğrenme deneyimleri sunarak, her öğrencinin öğrenme sürecini hızlandırmak ve daha verimli hale getirmektir.
            </p>
            
            <p>
              Progenx platformu, kullanıcı verilerini analiz ederek, öğrencilere özel öğrenme materyalleri ve içerikler sunmakta, bu sayede her öğrencinin en verimli şekilde öğrenmesini sağlamaktadır. Projemizin sunduğu bu özellikler, eğitimde bireyselleşmeyi desteklerken, aynı zamanda öğrencilerin motivasyonlarını artırmaya yönelik çözümler de geliştirmektedir.
            </p>
          </div>
          
          <div className="academy-features">
            <h3 className="features-title">Platformumuzun Özellikleri</h3>
            
            <div className="features-grid">
              <div className="feature-item">
                <h4>Kişiselleştirilmiş Eğitim Planları</h4>
                <p>Öğrencilerin bireysel öğrenme hızlarına, güçlü ve zayıf yönlerine göre optimize edilmiş özel eğitim programları oluşturur.</p>
              </div>
              
              <div className="feature-item">
                <h4>Unutma Eğrisine Dayalı Geri Bildirim</h4>
                <p>Yapay zeka destekli algoritmalar, öğrencilerin unutma eğrisine uygun olarak tekrar etmeleri gereken konuları belirler ve onlara özel testler önerir. Bu sayede bilgiler kalıcı hale gelir.</p>
              </div>
              
              <div className="feature-item">
                <h4>Yapay Zeka Destekli Soru Çözümü</h4>
                <p>Öğrencilerin zorlandıkları soruların çözümünü gösteren yapay zeka destekli sistemler, öğretmen onaylı çözümlerle birleşerek yüksek doğruluk oranı sunar.</p>
              </div>
              
              <div className="feature-item">
                <h4>Motivasyon ve Gelişim Desteği</h4>
                <p>Öğrencilerin motivasyonunu artırmak için kişisel başarı grafiklerini ve anlık geri bildirimleri içeren mekanizmalar sunar.</p>
              </div>
            </div>
          </div>
          
          <div className="academy-packages">
            <h3 className="packages-title">Paketlerimiz</h3>
            <p className="packages-subtitle">İhtiyaçlarınıza uygun çözümler sunuyoruz</p>
            
            <div className="packages-row">
              <div className="package-column">
                <div className="package-card">
                  <h4 className="package-title">5, 6 ve 7. Sınıflar</h4>
                  <ul className="package-features">
                    <li>Aylık 100 soru sorma hakkı (Yapay zeka destekli)</li>
                    <li>Seviye bazlı akıllı soru önerileri</li>
                    <li>100.000+ soru havuzu, 10'dan fazla yayınevinden içerik</li>
                    <li>Kişiye özel aylık ve haftalık çalışma planları</li>
                    <li>Her hafta bireyselleştirilmiş konu eksik raporu</li>
                    <li>Veliye özel gelişim paneli</li>
                    <li>Öğretmene sor sistemi</li>
                    <li>Öğrenci seviyesine göre içerik eşleşmesi</li>
                    <li>Her yıl üyeliğini yenileyene kademeli indirim avantajı</li>
                  </ul>
                  <div className="package-cta">
                    <a href="https://app.progenxacademy.com/login" 
                       target="_blank" 
                       rel="noopener noreferrer" 
                       className="btn btn-primary">Giriş Yap</a>
                  </div>
                </div>
              </div>
              
              <div className="package-column">
                <div className="package-card">
                  <h4 className="package-title">YKS 2026 (9, 10, 11, 12. Sınıflar)</h4>
                  <p className="package-subtitle">TYT - AYT Hazırlık 2026 Dönemi</p>
                  <ul className="package-features">
                    <li>Aylık 150 soru sorma hakkı (Yapay zeka destekli)</li>
                    <li>Hedef bazlı kişiselleştirilmiş çalışma planları</li>
                    <li>200.000+ soru, 200'den fazla kitap</li>
                    <li>Konu tarama testleri, Türkiye geneli deneme sınavları</li>
                    <li>İleri seviye eksik analiz sistemi</li>
                    <li>Öğrenci performans takibi ve veli erişim paneli</li>
                    <li>Öğretmene sor sistemi (Sınırsız)</li>
                    <li>Her yıl üyeliğini yenileyene kademeli indirim avantajı</li>
                  </ul>
                  <div className="package-cta">
                    <a href="https://app.progenxacademy.com/login" 
                       target="_blank" 
                       rel="noopener noreferrer" 
                       className="btn btn-primary">Giriş Yap</a>
                  </div>
                </div>
              </div>

              <div className="package-column">
                <div className="package-card">
                  <h4 className="package-title">LGS 2026 (8. Sınıflar)</h4>
                  <p className="package-subtitle">2026 Sınav Dönemine Özel</p>
                  <ul className="package-features">
                    <li>Aylık 150 soru sorma hakkı (Yapay zeka destekli)</li>
                    <li>Seviye bazlı akıllı soru önerileri</li>
                    <li>100.000+ soru havuzu, 10'dan fazla yayınevinden içerik</li>
                    <li>Kişiye özel aylık ve haftalık çalışma planları</li>
                    <li>Her hafta bireyselleştirilmiş konu eksik raporu</li>
                    <li>Türkiye geneli denemeler + konu tarama testleri</li>
                    <li>Hediye çalışma materyalleri</li>
                    <li>Veliye özel gelişim paneli</li>
                    <li>Öğretmene sor sistemi</li>
                    <li>Öğrenci seviyesine göre içerik eşleşmesi</li>
                    <li>Her yıl üyeliğini yenileyene kademeli indirim avantajı</li>
                  </ul>
                  <div className="package-cta">
                    <a href="https://app.progenxacademy.com/login" 
                       target="_blank" 
                       rel="noopener noreferrer" 
                       className="btn btn-primary">Giriş Yap</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <section className="academy-faq">
            <h3 className="section-title">Sıkça Sorulan Sorular</h3>
            <div className="faq-container">
              <div className="faq-item">
                <h4 className="faq-question">ProgenX Akademi nedir ve nasıl çalışır?</h4>
                <p className="faq-answer">
                  ProgenX Akademi, yapay zeka destekli kişiselleştirilmiş öğrenme platformudur. Öğrencilerin bireysel öğrenme hızlarına, güçlü ve zayıf yönlerine göre optimize edilmiş özel eğitim programları oluşturur. Platform, kullanıcı verilerini analiz ederek öğrencilere özel öğrenme materyalleri ve içerikler sunar.
                </p>
              </div>
              <div className="faq-item">
                <h4 className="faq-question">Hangi sınıf seviyeleri için paketler mevcut?</h4>
                <p className="faq-answer">
                  ProgenX Akademi, 5-7. sınıflar, 8. sınıf (LGS 2026) ve 9-12. sınıflar (YKS 2026) için özel paketler sunmaktadır. Her paket, ilgili sınıf seviyesine uygun içerikler ve özellikler içerir.
                </p>
              </div>
              <div className="faq-item">
                <h4 className="faq-question">Yapay zeka destekli soru çözümü nasıl çalışır?</h4>
                <p className="faq-answer">
                  Öğrencilerin zorlandıkları soruların çözümünü gösteren yapay zeka destekli sistemler, öğretmen onaylı çözümlerle birleşerek yüksek doğruluk oranı sunar. Her soru için detaylı açıklamalar ve benzer soru önerileri sağlanır.
                </p>
              </div>
              <div className="faq-item">
                <h4 className="faq-question">Unutma eğrisine dayalı geri bildirim nedir?</h4>
                <p className="faq-answer">
                  Yapay zeka destekli algoritmalar, öğrencilerin unutma eğrisine uygun olarak tekrar etmeleri gereken konuları belirler ve onlara özel testler önerir. Bu sayede bilgiler kalıcı hale gelir ve öğrenme verimliliği artar.
                </p>
              </div>
              <div className="faq-item">
                <h4 className="faq-question">Hangi cihazlardan erişebilirim?</h4>
                <p className="faq-answer">
                  ProgenX Akademi'ye bilgisayar, tablet ve akıllı telefonlar üzerinden erişebilirsiniz. Web tarayıcısı üzerinden veya iOS ve Android mobil uygulamaları aracılığıyla kullanabilirsiniz.
                </p>
              </div>
              <div className="faq-item">
                <h4 className="faq-question">Veli ve öğretmen panelleri var mı?</h4>
                <p className="faq-answer">
                  Evet, ProgenX Akademi'de velilere özel gelişim paneli ve öğretmenlere sor sistemi bulunmaktadır. Veliler öğrencinin ilerlemesini takip edebilir, öğretmenler ise öğrencilerine destek sağlayabilir.
                </p>
              </div>
            </div>
          </section>
          
          <div className="app-download-section">
            <h3 className="section-title">Uygulamamıza Hemen Erişin</h3>
            <p className="app-download-subtitle">İster web tarayıcınızdan, ister mobil cihazınızdan - ProgenX her zaman yanınızda!</p>
            
            <div className="app-badges">
              <a href="https://app.progenxacademy.com/" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 className="badge-link">
                <img src={webAppBadge} 
                     alt="Web Uygulaması" 
                     className="app-badge" />
              </a>
              
              <a href="https://play.google.com/store/apps/details?id=com.ProgenxAcademy.progenx" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 className="badge-link">
                <img src={googlePlayBadge} 
                     alt="Google Play'den İndir" 
                     className="app-badge" />
              </a>
              
              <a href="https://apps.apple.com/tr/app/progenx/id6744415621?l=tr" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 className="badge-link">
                <img src={appStoreBadge} 
                     alt="App Store'dan İndir" 
                     className="app-badge" />
              </a>
            </div>
          </div>

        </div>
      </section>
      
      <CallToAction 
        title="Eğitimde Yapay Zeka Devrimi Başlıyor!"
        subtitle="Geleceğin eğitim teknolojilerini keşfetmek için bize katılın."
        buttonText="Bize Ulaşın" 
        buttonLink="/iletisim" 
      />
    </div>
  );
};

export default Academy; 